<db-dialog-wrapper [dialog]="this" [width]="'500px'" [className]="'db-2fa-disable-wrap'">
  <div class="db-disable-2fa">
    <div class="db-disable-2fa-header">
      <div class="db-disable-header-title">{{'text_disable2faTitle' | dbText}}</div>
      <div class="db-disable-header-desc">{{'text_disable2faDesc' | dbText}}</div>
    </div>
    <form [formGroup]="disable2faForm" *ngIf="activeBlock === 'google-authenticator'">
      <div class="ds-input-wrap">
        <span class="ds-input-label">{{'text_disable2faLabelAuthenticator' | dbText}}</span>
        <input type="text" class="ds-input" formControlName="disable2faCode"
               [ngClass]="{'error': disable2faForm?.controls['disable2faCode']?.touched && disable2faForm?.controls['disable2faCode']?.invalid}">
        <span class="ds-input-error-msg" [innerHTML]="(disable2faForm?.controls['disable2faCode']?.touched && disable2faForm?.controls['disable2faCode']?.invalid) || (disable2faForm.controls['disable2faCode'].invalid && ((disable2faForm.controls['disable2faCode'].touched && !disable2faForm.controls['disable2faCode'].errors['required']) || formSubmitted)) ? ('text_empty2fa' | dbText )
        : disable2faForm.controls['disable2faCode'].invalid && ((disable2faForm.controls['disable2faCode'].touched && !disable2faForm.controls['disable2faCode'].errors['required']) || formSubmitted)  ||  (serverErrors && serverErrors.fields && serverErrors.fields['2fa_token']) ? serverErrors && serverErrors.fields && serverErrors?.fields['2fa_token'] && serverErrors.fields['2fa_token'][0]
        : disable2faForm.controls['disable2faCode'].invalid && ((disable2faForm.controls['disable2faCode'].touched && !disable2faForm.controls['disable2faCode'].errors['required']) || formSubmitted)  ||  (serverErrors && serverErrors.fields && !serverErrors.fields['2fa_token']) ? serverErrors.message : ''"></span>
      </div>
    </form>
    <form [formGroup]="disable2faRecoveryForm" *ngIf="activeBlock === 'google-recovery'">
      <div class="ds-input-wrap">
        <span class="ds-input-label">{{'text_disable2faLabelRecovery' | dbText}}</span>
        <input type="text" class="ds-input" formControlName="disable2faRecovery"
               [ngClass]="{'error': disable2faRecoveryForm.controls['disable2faRecovery'].invalid
               && ((disable2faRecoveryForm.controls['disable2faRecovery'].touched
               && !disable2faRecoveryForm.controls['disable2faRecovery'].errors['required']) || formSubmitted)
               || (serverErrors && serverErrors.message)}">
        <span class="ds-input-error-msg"
              [innerHTML]="(disable2faRecoveryForm.controls['disable2faRecovery'].invalid
              && disable2faRecoveryForm.controls['disable2faRecovery'].touched)
              || (disable2faRecoveryForm.controls['disable2faRecovery'].invalid
              && ((disable2faRecoveryForm.controls['disable2faRecovery'].touched
        && !disable2faRecoveryForm.controls['disable2faRecovery'].errors['required']) || formSubmitted)) ? ('text_empty2fa' | dbText)
        : (disable2faRecoveryForm.controls['disable2faRecovery'].invalid
          && ((disable2faRecoveryForm.controls['disable2faRecovery'].touched
          && !disable2faRecoveryForm.controls['disable2faRecovery'].errors['required']) || formSubmitted)
          && (serverErrors && serverErrors.fields && !serverErrors.fields['2fa_token']))
          ||  (serverErrors && serverErrors.fields && !serverErrors.fields['2fa_token']) ? serverErrors.message : '' "></span>
      </div>
    </form>
    <div class="db-disable-2fa-button">
      <a class="ds-btn-m ds-btn-red" (click)="disable2fa(activeBlock)">
        <span *ngIf="!loading">Disable</span>
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      </a>
    </div>
  </div>
  <div class="db-disable-2fa-footer">
    <div *ngIf="activeBlock === 'google-authenticator'" (click)="changeBlock()">
      <div class="db-disable-2fa-footer-icon">
        <i class="db-icon db-icon-recovery"></i>
      </div>
      <div class="db-disable-2fa-footer-text">
        <div class="db-disable-2fa-footer-text-title">{{'text_disable2faTroubleTitle' | dbText}}</div>
        <div class="db-disable-2fa-footer-text-desc">{{'text_disable2faTroubleDesc' | dbText}}</div>
      </div>
    </div>
    <div *ngIf="activeBlock === 'google-recovery'" (click)="changeBlock()">
      <div class="db-disable-2fa-footer-image">
        <img class="db-icon-google-authenticator" src="assets/images/google/google-authenticator.svg" alt=""/>
      </div>
      <div class="db-disable-2fa-footer-text">
        <div class="db-disable-2fa-footer-text-title">{{'text_disable2faVerifTitle' | dbText}}</div>
        <div class="db-disable-2fa-footer-text-desc">{{'text_disable2faVerifDesc' | dbText}}</div>
      </div>
    </div>
  </div>
</db-dialog-wrapper>
